import { SET_PAGE_NUMBER_IN_STORE } from './types';

export const setPageNumberInStore = (data) => {
  return {
    type: SET_PAGE_NUMBER_IN_STORE,
    data,
  };
};
